import {agendaDirectory} from "./access/patientDirectory";
import {
  getDeviceTimeZone,
  localizeScheduleEntry
} from "./utils/timezone";
import {patientDirectory} from "./access/patientDirectory";
import {
  useEffect,
  useState,
  useRef
} from "react";

import {
  db,
  storage
} from "./firebase";

import {
  sendWhatsAppVPS,
  sendWhatsAppFileVPS,
  sendFileToWhatsApp
} from "./services/whatsappVPS";

import { useClinic }
  from "./context/ClinicContext";

import {
  usePatient
} from "./PatientContext";

import PacienteForm
  from "./PacienteForm";

import {
    collection,
    onSnapshot,
    query,
    orderBy,
    addDoc,
    doc,
    getDoc,
    getDocs,
    updateDoc,
    deleteDoc,
    where,
    limit,
    writeBatch
} from "./access/firestore";

import {
  ref,
  uploadBytes,
  getDownloadURL
} from "firebase/storage";

import FileViewerModal
  from "./FileViewerModal";

import EmojiPicker from "emoji-picker-react";
import {
  Paperclip,
  Smile,
  Mic,
  Square,
  Send,
  LoaderCircle,
  Image as ImageIcon,
  FileText
} from "lucide-react";
import { requestVexaPrompt } from "./notifications/dialogService";
import {
  WhatsAppAvatar,
  WhatsAppThread
} from "./whatsapp/WhatsAppMessageBubble";

function FileBadge({

    type,

    color,

    filename,

    buttonText,

    onOpen

}) {

    return (

        <div
        style={{
            minWidth:220
        }}
        >

            <div
            style={{
                width:56,
                height:56,
                borderRadius:12,
                background:color,
                color:"#fff",
                fontWeight:700,
                fontSize:16,
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                marginBottom:10
            }}
            >

                {type}

            </div>

            <div
            style={{
                fontSize:14,
                fontWeight:500,
                wordBreak:"break-word",
                marginBottom:10
            }}
            >

                {filename}

            </div>

            <button

                onClick={onOpen}

                style={{

                    width:"100%",

                    padding:"10px 14px",

                    background:"#2563eb",

                    color:"#fff",

                    border:"none",

                    borderRadius:10,

                    cursor:"pointer",

                    fontWeight:600

                }}

            >

                {buttonText}

            </button>

        </div>

    );

}

export default function WhatsAppPanel({

  setSeccion,

  pendingAction,

  setPendingAction

}) {

  const {
    clinicData,
    clinicId
  } = useClinic();
  const deviceTimeZone = getDeviceTimeZone();

  const {
    setSelectedPatient
  } = usePatient();

  const [
    conversations,
    setConversations
  ] = useState([]);

  const [
    selectedConversation,
    setSelectedConversation
  ] = useState(null);

  const [
    creatingChat,
    setCreatingChat
  ] = useState(false);

  const [
    messages,
    setMessages
  ] = useState([]);

  const [
    patientSummary,
    setPatientSummary
  ] = useState({
    nextAppointment: null,
    balance: 0,
    lastTreatment: "-"
  });

  const [
    newMessage,
    setNewMessage
  ] = useState("");

  const [
    showEmojiPicker,
    setShowEmojiPicker
  ] = useState(false);

  const [
    showAttachmentMenu,
    setShowAttachmentMenu
  ] = useState(false);

  const [
    selectedFile,
    setSelectedFile
  ] = useState(null);

  const [
    showFilePreview,
    setShowFilePreview
  ] = useState(false);

  const [
    previewUrl,
    setPreviewUrl
  ] = useState("");

  const [
    fileCaption,
    setFileCaption
  ] = useState("");

  const [
    uploadingFile,
    setUploadingFile
  ] = useState(false);

  const [
    sending,
    setSending
  ] = useState(false);

  const [
    showCreatePatient,
    setShowCreatePatient
  ] = useState(false);

  const [
    viewerOpen,
    setViewerOpen
    ] = useState(false);

    const [
    viewerUrl,
    setViewerUrl
    ] = useState("");

    const [
    viewerName,
    setViewerName
    ] = useState("");

    const [
    viewerMimeType,
    setViewerMimeType
    ] = useState("");

    const [
        showDeleteConversationModal,
        setShowDeleteConversationModal
    ] = useState(false);

    const [
    showNewChatModal,
    setShowNewChatModal
    ] = useState(false);

    const [
    countryCode,
    setCountryCode
    ] = useState("+52");

    const [
    phoneSearch,
    setPhoneSearch
    ] = useState("");

    const [
    patientSearch,
    setPatientSearch
    ] = useState("");

    const [
    patientsFound,
    setPatientsFound
    ] = useState([]);

    const [
    recentPatients,
    setRecentPatients
    ] = useState([]);

    const [
    isRecording,
    setIsRecording
    ] = useState(false);

    const [
    audioBlob,
    setAudioBlob
    ] = useState(null);

    const [
    audioPreview,
    setAudioPreview
    ] = useState("");

    const [
    recordingTime,
    setRecordingTime
    ] = useState(0);

    const [
        emojiPickerPosition,
        setEmojiPickerPosition
    ] = useState({
        left:0,
        top:0
    });

    const [showLinkPatientModal, setShowLinkPatientModal] = useState(false);

    const [linkConversation, setLinkConversation] = useState(null);

    const [linkPatientSearch, setLinkPatientSearch] = useState("");

    const [linkPatientsFound, setLinkPatientsFound] = useState([]);

    const [linkingPatient, setLinkingPatient] = useState(false);

      useEffect(() => {

        if (!pendingAction) {

            return;

        }

        if (

            pendingAction.type === "conversation"

        ) {

            if (

                conversations.length === 0

            ) {

                return;

            }

            const conversation = conversations.find(

                c =>

                    c.id === pendingAction.conversationId

            );

            if (!conversation) {

                console.log(
                    "Esperando conversación..."
                );

                return;

            }

            console.log(
                "Conversación encontrada"
            );

            setSelectedConversation(
                conversation
            );

            setPendingAction(null);

            return;

        }

        if (

            pendingAction.type === "patient"

        ) {

            const conversation = conversations.find(

                c =>

                    c.patientId === pendingAction.patientId

            );

            if (conversation) {

                setSelectedConversation(
                    conversation
                );

            }

            setSelectedPatient({

                id: pendingAction.patientId

            });

            setSeccion(
                "pacientes"
            );

            setPendingAction(null);

        }

    }, [

        pendingAction,

        conversations,

        setPendingAction,

        setSelectedPatient,

        setSeccion

    ]);

    const countryCodes = [

        {
            flag:"🇲🇽",
            name:"México",
            code:"+52"
        },

        {
            flag:"🇺🇸",
            name:"USA",
            code:"+1"
        },

        {
            flag:"🇨🇦",
            name:"Canadá",
            code:"+1"
        },

        {
            flag:"🇨🇴",
            name:"Colombia",
            code:"+57"
        },

        {
            flag:"🇦🇷",
            name:"Argentina",
            code:"+54"
        },

        {
            flag:"🇨🇱",
            name:"Chile",
            code:"+56"
        },

        {
            flag:"🇪🇸",
            name:"España",
            code:"+34"
        }

    ];

    const openFileViewer = (
    fileUrl,
    filename,
    mimeType
    ) => {

    setViewerUrl(
        fileUrl
    );

    setViewerName(
        filename || ""
    );

    setViewerMimeType(
        mimeType || ""
    );

    setViewerOpen(
        true
    );

    };

  const messagesEndRef =
    useRef(null);

  const fileInputRef =
    useRef(null);  

  const mediaRecorderRef =
    useRef(null);

  const audioChunksRef =
    useRef([]);

  const recordingIntervalRef =
    useRef(null);  

  const emojiButtonRef =
    useRef(null);

  const emojiPickerRef =
    useRef(null);

  const messageInputRef =
    useRef(null);     

  async function handleSendMessage() {

    if (
        !newMessage.trim() ||
        !selectedConversation
    ) {
        return;
    }

    const phone = (
        selectedConversation.whatsapp ||
        selectedConversation.id ||
        ""
    )
    .replace("@c.us", "")
    .replace(/\D/g, "");
        const result =
            await sendWhatsAppVPS(

                clinicId,

                phone,

                newMessage,

                selectedConversation.patientId,

                selectedConversation.patientName

            );

    if (result?.success) {

        setNewMessage("");

        setSending(false);

    } else {

        console.log(
        "RESULTADO COMPLETO:",
        result
        );

        alert(
        JSON.stringify(
            result,
            null,
            2
        )
        );

        setSending(false);

    }
  }

  async function handleNewChat() {

    const phone = await requestVexaPrompt(
        "Número WhatsApp (solo números, ejemplo: 6561234567)",
        {
          title: "Iniciar conversación",
          inputType: "tel",
          inputMode: "tel",
          placeholder: "6561234567",
          confirmText: "Continuar"
        }
    );

    if (!phone) {
        return;
    }

    const cleanPhone =
        phone.replace(/\D/g, "");

    const conversation = {

        id: `${cleanPhone}@c.us`,

        whatsapp: cleanPhone,

        patientId: null,

        patientName: "",

        lastMessage: "",

        unreadCount: 0

    };

    setSelectedConversation(
        conversation
    );

  }

  async function searchPatients(
    text,
    target = "newChat"
  ) {

    setPatientSearch(text);

    if (!text.trim()) {

        setPatientsFound([]);

        return;
    }

    try {

        const pacientesRef =
        patientDirectory(db,clinicId);

        const snap =
        await getDocs(
            pacientesRef
        );

        const encontrados =
        snap.docs
            .map(doc => ({
            id: doc.id,
            ...doc.data()
            }))
            .filter(patient => {

            const nombre =

                `${patient.nombre || ""} ${patient.apellidos || ""}`
                .toLowerCase();

            const telefono =
                (
                patient.whatsapp || ""
                ).toLowerCase();

            const term =
                text.toLowerCase();

            return (

                nombre.includes(term)

                ||

                telefono.includes(term)

            );

            })
            .slice(0,20);

        if (target === "link") {

            setLinkPatientsFound(
                encontrados
            );

        } else {

            setPatientsFound(
                encontrados
            );

        }

    } catch(error) {

        console.error(error);

    }

  }

  async function loadRecentPatients() {

    try {

        const pacientesRef =
        patientDirectory(db,clinicId);

        const pacientesQuery =
        query(
            pacientesRef,
            orderBy(
            "createdAt",
            "desc"
            ),
            limit(20)
        );

        const snap =
        await getDocs(
            pacientesQuery
        );

        setRecentPatients(

        snap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
        }))

        );

    } catch(error) {

        console.error(
        "Error cargando recientes:",
        error
        );

    }

  }

  function handleFileSelected(
    event
    ) {

    const file =
        event.target.files?.[0];

    if (!file) {
        return;
    }

    setSelectedFile(
        file
    );

    const url =
        URL.createObjectURL(
            file
        );

    setPreviewUrl(
        url
    );

    setShowFilePreview(
        true
    );

  }

  function openAttachmentPicker(accept) {

    if (fileInputRef.current) {
      fileInputRef.current.accept = accept;
      fileInputRef.current.click();
    }

    setShowAttachmentMenu(false);

  }

  async function startRecording() {

    try {

        const stream =
        await navigator.mediaDevices.getUserMedia({
            audio:true
        });

        const mediaRecorder =
        new MediaRecorder(stream);

        mediaRecorderRef.current =
        mediaRecorder;

        audioChunksRef.current =
        [];

        mediaRecorder.ondataavailable =
        event => {

            if (event.data.size > 0) {

            audioChunksRef.current.push(
                event.data
            );

            }

        };

        mediaRecorder.onstop = () => {

        const blob =
            new Blob(
            audioChunksRef.current,
            {
                type:"audio/webm"
            }
            );

        setAudioBlob(
            blob
        );

        setAudioPreview(
            URL.createObjectURL(
            blob
            )
        );

        stream
            .getTracks()
            .forEach(track =>
            track.stop()
            );

        };

        mediaRecorder.start();

        setRecordingTime(0);

        recordingIntervalRef.current =
        setInterval(() => {

            setRecordingTime(
            prev => prev + 1
            );

        },1000);

        setIsRecording(true);

    } catch(error) {

        console.error(error);

        alert(
        "No se pudo acceder al micrófono"
        );

    }

  }

  function stopRecording() {

    if (
        mediaRecorderRef.current
    ) {

        mediaRecorderRef.current.stop();

    }

    clearInterval(
        recordingIntervalRef.current
    );

    setIsRecording(false);

  }

  async function confirmDeleteConversation() {

    if (!selectedConversation) {
        return;
    }

    try {

        const messagesRef = collection(

            db,

            "clinics",

            clinicId,

            "whatsappConversations",

            selectedConversation.id,

            "messages"

        );

        const messagesSnap = await getDocs(messagesRef);

        const BATCH_SIZE = 450;

        let batch = writeBatch(db);

        let operationCount = 0;

        for (const message of messagesSnap.docs) {

            batch.delete(
                message.ref
            );

            operationCount++;

            if (operationCount >= BATCH_SIZE) {

                await batch.commit();

                batch = writeBatch(db);

                operationCount = 0;

            }

        }

        batch.delete(

            doc(

                db,

                "clinics",

                clinicId,

                "whatsappConversations",

                selectedConversation.id

            )

        );

        await batch.commit();

        setSelectedConversation(null);

        setShowDeleteConversationModal(
            false
        );

    } catch(error) {

        console.error("ERROR ELIMINANDO CONVERSACIÓN:", error);

        console.error(error.stack);

        setShowDeleteConversationModal(false);

        alert(error.message);

    }

  }

  async function loadPatientSummary(
    patientId
    ) {

    try {

        const citasQuery = query(

        agendaDirectory(db,clinicId),

        where(
            "pacienteId",
            "==",
            patientId
        )

        );

        const citasSnap =
        await getDocs(
            citasQuery
        );

        const citas =
        citasSnap.docs.map(
            doc => localizeScheduleEntry({
            id: doc.id,
            ...doc.data()
            }, deviceTimeZone)
        );

        const now = new Date();

        const futuras = citas
        .filter(cita => {

            if (
            cita.estado ===
            "cancelada"
            ) {
            return false;
            }

            const fechaHora =
            new Date(
                `${cita.fecha}T${cita.hora}`
            );

            return fechaHora >= now;

        })
        .sort((a, b) => {

            const fechaA =
            new Date(
                `${a.fecha}T${a.hora}`
            );

            const fechaB =
            new Date(
                `${b.fecha}T${b.hora}`
            );

            return fechaA - fechaB;

        });

        const proximaCita =
        futuras[0] || null;

        const saldoTotal =
        citas.reduce(
            (acc, cita) => {

            if (
                cita.estado === "cancelada"
            ) {
                return acc;
            }

            return (
                acc +
                Number(cita.saldo || 0)
            );

            },
            0
        );

        const ultimaCita =
        citas
            .filter(
            cita =>
                cita.estado !==
                "cancelada"
            )
            .sort((a, b) => {

            const fechaA =
                new Date(
                `${a.fecha}T${a.hora}`
                );

            const fechaB =
                new Date(
                `${b.fecha}T${b.hora}`
                );

            return fechaB - fechaA;

            })[0];

        setPatientSummary({

        nextAppointment:
            proximaCita,

        balance:
            saldoTotal,

        lastTreatment:
            ultimaCita?.motivo || "-"

        });

    } catch (error) {

        console.error(
        "Error cargando resumen:",
        error
        );

    }

  }

  useEffect(() => {

    if (!clinicId) {
      return;
    }

    const q = query(

      collection(
        db,
        "clinics",
        clinicId,
        "whatsappConversations"
      ),

      orderBy(
        "lastMessageAt",
        "desc"
      )

    );

    const unsubscribe =
      onSnapshot(
        q,
        snapshot => {

          setConversations(

            snapshot.docs.map(
              doc => ({
                id: doc.id,
                ...doc.data()
              })
            )

          );

        }
      );

    return unsubscribe;

  }, [clinicId]);

  useEffect(() => {
    if (!selectedConversation?.id) return;
    const liveConversation = conversations.find(item => item.id === selectedConversation.id);
    if (liveConversation) setSelectedConversation(liveConversation);
  }, [conversations]);

  useEffect(()=>{

    function handleClick(event){

        if(

            emojiPickerRef.current &&

            !emojiPickerRef.current.contains(event.target)

            &&

            !emojiButtonRef.current.contains(event.target)

        ){

            setShowEmojiPicker(false);

        }

    }

    document.addEventListener(
        "mousedown",
        handleClick
    );

    return ()=>{

        document.removeEventListener(
            "mousedown",
            handleClick
        );

    };

  },[]);

  useEffect(()=>{

    function handleKey(event){

        if(event.key==="Escape"){

            setShowEmojiPicker(false);

        }

    }

    window.addEventListener(
        "keydown",
        handleKey
    );

    return ()=>{

        window.removeEventListener(
            "keydown",
            handleKey
        );

    };

  },[]);

  useEffect(() => {

    if (!selectedConversation) {

        setMessages([]);

        return;
    }

    const q = query(

        collection(
        db,
        "clinics",
        clinicId,
        "whatsappConversations",
        selectedConversation.id,
        "messages"
        ),

        orderBy(
        "timestamp",
        "asc"
        )

    );

    const unsubscribe =
        onSnapshot(
        q,
        snapshot => {

            setMessages(

            snapshot.docs.map(
                doc => ({
                id: doc.id,
                ...doc.data()
                })
            )

            );

        }
        );

    return unsubscribe;

    }, [
    clinicId,
    selectedConversation
  ]);

  useEffect(()=>{

    function updatePosition(){

        if(

            !showEmojiPicker ||

            !emojiButtonRef.current

        ){

            return;

        }

        const rect =
            emojiButtonRef.current.getBoundingClientRect();

        setEmojiPickerPosition({

            left:rect.left,

            top:rect.top

        });

    }

    window.addEventListener(
        "resize",
        updatePosition
    );

    window.addEventListener(
        "scroll",
        updatePosition,
        true
    );

    return ()=>{

        window.removeEventListener(
            "resize",
            updatePosition
        );

        window.removeEventListener(
            "scroll",
            updatePosition,
            true
        );

    };

  },[
    showEmojiPicker
  ]);

  useEffect(() => {

    messagesEndRef.current
        ?.scrollIntoView({
        behavior:"smooth"
        });

  }, [messages]);

  useEffect(() => {

    if (
        !selectedConversation?.patientId
    ) {

        setPatientSummary({
        nextAppointment: null,
        balance: 0,
        lastTreatment: "-"
        });

        return;
    }

    loadPatientSummary(
        selectedConversation.patientId
    );

    }, [
    selectedConversation,
    clinicId
    ]);

  return (

    <div className="vd-module-page vd-whatsapp-page" style={{
      display:"flex",
      height:"calc(100vh - 40px)",
      background:"#fff",
      borderRadius:16,
      overflow:"hidden"
    }}>

      {/* CONVERSACIONES */}

      <div className="vd-whatsapp-inbox" style={{
        width:350,
        borderRight:
          "1px solid #e5e7eb",
        overflowY:"auto"
      }}>

        <div className="vd-whatsapp-inbox-header" style={{
            padding:20,
            borderBottom:
                "1px solid #e5e7eb"
            }}>

            <div style={{
                fontSize:20,
                fontWeight:700,
                marginBottom:12
            }}>

                WhatsApp

            </div>

            <button className="vd-whatsapp-new-chat" 

                onClick={async () => {

                    await loadRecentPatients();

                    setShowNewChatModal(
                        true
                    );

                }}

                style={{
                width:"100%",
                padding:12,
                border:"none",
                borderRadius:10,
                background:"#2563eb",
                color:"#fff",
                cursor:"pointer",
                fontWeight:600
                }}

            >

                + Nuevo Chat

            </button>

        </div>

        {conversations.map(
          conversation => (

            <div className="vd-whatsapp-conversation-item"
                key={conversation.id}

                onClick={async () => {

                    setSelectedConversation(
                        conversation
                    );

                    try {

                        await updateDoc(

                        doc(
                            db,
                            "clinics",
                            clinicId,
                            "whatsappConversations",
                            conversation.id
                        ),

                        {
                            unreadCount: 0
                        }

                        );

                    } catch (error) {

                        console.error(error);

                    }

                    }}

                style={{
                    padding:16,

                    borderBottom:
                    "1px solid #f1f5f9",

                    cursor:"pointer",

                    background:

                    selectedConversation?.id ===
                    conversation.id

                        ? "#eff6ff"

                        : conversation.unreadCount > 0

                        ? "#f0fdf4"

                        : "#fff"
                }}
            >   

              <div
                style={{
                    display:"flex",
                    justifyContent:"space-between",
                    alignItems:"center"
                }}
                >

                <WhatsAppAvatar conversation={conversation} size={42} />

                <div
                    style={{
                        fontWeight:
                        conversation.unreadCount > 0
                            ? 700
                            : 600,

                        color:"#111827"
                    }}
                >

                    {conversation.patientName
                    ? conversation.patientName
                    : "Prospecto"}

                </div>

                {conversation.unreadCount > 0 && (

                    <div
                        style={{
                        width:10,
                        height:10,
                        borderRadius:"50%",
                        background:"#22c55e",
                        marginLeft:"auto",
                        marginRight:8
                        }}
                    />

                    )}

                {conversation.unreadCount > 0 && (

                    <div
                    style={{
                        background:"#22c55e",
                        color:"#fff",
                        minWidth:22,
                        height:22,
                        borderRadius:"50%",
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"center",
                        fontSize:12,
                        fontWeight:700,
                        padding:"0 6px"
                    }}
                    >

                    {conversation.unreadCount}

                    </div>

                )}

                </div>

              {!conversation.patientId && (

                <div style={{
                    marginTop:6,
                    display:"flex",
                    gap:8
                }}>

                    <button
                    onClick={(e) => {

                        e.stopPropagation();

                        setSelectedConversation(
                        conversation
                        );

                        setShowCreatePatient(
                        true
                        );

                    }}
                    style={{
                        border:"none",
                        borderRadius:8,
                        padding:"4px 10px",
                        cursor:"pointer",
                        background:"#dcfce7"
                    }}
                    >

                    Crear paciente

                    </button>

                    <button
                        onClick={(e) => {

                            e.stopPropagation();

                            setLinkConversation(conversation);
                            setLinkPatientSearch("");
                            setLinkPatientsFound([]);
                            setShowLinkPatientModal(true);

                        }}
                        style={{
                            border:"none",
                            borderRadius:8,
                            padding:"4px 10px",
                            cursor:"pointer",
                            background:"#dbeafe"
                        }}
                    >

                        Vincular paciente

                    </button>

                </div>

                )}

              <div style={{
                color:"#64748b",
                fontSize:13,
                marginTop:4,

                fontWeight:
                    conversation.unreadCount > 0
                    ? 600
                    : 400
              }}>

                {conversation.lastMessage}

                </div>

                <div style={{
                fontSize:11,
                color:"#94a3b8",
                marginTop:6
                }}>

                {conversation.lastMessageAt?.toDate
                    ? conversation.lastMessageAt
                        .toDate()
                        .toLocaleTimeString(
                        [],
                        {
                            hour:"2-digit",
                            minute:"2-digit"
                        }
                        )
                    : ""}

              </div>

            </div>

          )
        )}

      </div>

      {/* CHAT */}

        <div className="vd-whatsapp-conversation-stage" style={{
        flex:1,
        display:"flex",
        flexDirection:"column"
        }}>

        {!selectedConversation ? (

            <div style={{
            flex:1,
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            color:"#64748b"
            }}>

            Selecciona una conversación

            </div>

        ) : (

            <>

            <div className="vd-whatsapp-chat-header"
                style={{
                    padding:20,
                    borderBottom:
                    "1px solid #e5e7eb"
                }}
            >

                <div
                    style={{
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems:"center"
                    }}
                    >

                        <WhatsAppAvatar conversation={selectedConversation} size={46} />

                        <div

                            onClick={async () => {

                                if (
                                    !selectedConversation.patientId
                                ) {
                                    return;
                                }

                                try {

                                    const pacienteRef =
                                        doc(
                                            db,
                                            "clinics",
                                            clinicId,
                                            "pacientes",
                                            selectedConversation.patientId
                                        );

                                    const pacienteSnap =
                                        await getDoc(
                                            pacienteRef
                                        );

                                    if (
                                        !pacienteSnap.exists()
                                    ) {
                                        return;
                                    }

                                    setSelectedPatient({

                                        id:
                                            pacienteSnap.id,

                                        ...pacienteSnap.data()

                                    });

                                    setSeccion(
                                        "pacientes"
                                    );

                                } catch (err) {

                                    console.error(err);

                                }

                            }}

                            style={{
                                fontWeight:700,
                                color:"#2563eb",
                                cursor:"pointer",
                                fontSize:18
                            }}
                        >

                            {selectedConversation.patientName ||
                            selectedConversation.whatsapp}

                        </div>

                        <button

                            onClick={() =>

                                setShowDeleteConversationModal(
                                    true
                                )

                            }

                            style={{

                                background:"#ef4444",

                                color:"#fff",

                                border:"none",

                                padding:"8px 14px",

                                borderRadius:10,

                                cursor:"pointer",

                                fontWeight:600

                            }}

                        >

                            🗑 Eliminar

                    </button>

                </div>

                <div style={{
                    marginTop:8,
                    color:"#64748b",
                    fontSize:13,
                    display:"flex",
                    flexDirection:"column",
                    gap:4
                }}>

                    <div>
                        Próxima cita: {

                            patientSummary.nextAppointment
                            ? (() => {

                                const fecha = new Date(
                                    `${patientSummary.nextAppointment.fecha}T${patientSummary.nextAppointment.hora}`
                                );

                                return fecha.toLocaleString(
                                    "es-MX",
                                    {
                                    day: "numeric",
                                    month: "long",
                                    year: "numeric",
                                    hour: "numeric",
                                    minute: "2-digit",
                                    hour12: true
                                    }
                                );

                                })()
                            : "Sin cita programada"

                        }
                        </div>

                        <div>
                        Saldo pendiente: $

                        {patientSummary.balance.toLocaleString()}
                        </div>

                        <div>
                        Último tratamiento: {patientSummary.lastTreatment}
                    </div>

                </div>

            </div>

            <div className="vd-whatsapp-thread-shell" style={{
                flex:1,
                overflowY:"auto",
                padding:20
            }}>

                <WhatsAppThread
                    messages={messages}
                    onOpenFile={openFileViewer}
                    bottomRef={messagesEndRef}
                />

                <div style={{display:"none"}} aria-hidden="true">

                {messages.map(message => (

                <div
                    key={message.id}
                    style={{
                    marginBottom:12,
                    display:"flex",
                    justifyContent:
                        message.fromMe
                        ? "flex-end"
                        : "flex-start"
                    }}
                >

                    <div style={{

                        background:

                            message.type === "sticker"

                                ? "transparent"

                                : message.fromMe

                                    ? "#dcfce7"

                                    : "#f1f5f9",

                        padding:

                            message.type === "sticker"

                                ? 0

                                : "10px 14px",

                        borderRadius:12,

                        maxWidth:

                            message.type === "sticker"

                                ? 190

                                : "70%"

                    }}>

                        <div>

                        {
                        message.type === "file" ||

                        message.type === "image" ||

                        message.type === "document" ||

                        message.type === "audio" ||

                        message.type === "video" ||

                        message.type === "sticker"

                        ? (

                        <>

                            {
                                message.type === "image" && (

                                <img

                                    src={message.fileUrl}

                                    alt=""

                                    onClick={()=>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                    style={{

                                        maxWidth:260,

                                        maxHeight:260,

                                        borderRadius:12,

                                        cursor:"pointer",

                                        display:"block"

                                    }}

                                />

                                )
                            }

                            {
                                message.type === "sticker" && (

                                <img

                                    src={message.fileUrl}

                                    alt="Sticker"

                                    style={{

                                        width:170,

                                        height:"auto",

                                        display:"block",

                                        cursor:"pointer",

                                        userSelect:"none"

                                    }}

                                    onClick={()=>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {
                                message.type !== "sticker" &&

                                message.mimeType ===
                                "application/pdf" && (

                                <FileBadge

                                    type="PDF"

                                    color="#dc2626"

                                    filename={message.filename}

                                    buttonText="Ver PDF"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {
                                message.type !== "sticker" &&

                                message.mimeType?.startsWith(
                                    "audio/"
                                ) && (

                                    <div
                                        style={{

                                            minWidth:250,

                                            padding:10,

                                            borderRadius:12,

                                            background:

                                            message.fromMe

                                            ? "#a7d7b5"

                                            : "#d9dde3"

                                        }}
                                    >

                                        <audio

                                            controls

                                            preload="metadata"

                                            src={message.fileUrl}

                                            style={{
                                                width:"100%"
                                            }}

                                        />

                                        <div
                                            style={{
                                                marginTop:6,
                                                fontSize:12,
                                                color:"#475569",
                                                wordBreak:"break-word"
                                            }}
                                        >

                                            {message.filename}

                                        </div>

                                    </div>

                                )
                            }

                            {

                                message.type !== "sticker" &&

                                (

                                    message.mimeType ===
                                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document"

                                    ||

                                    message.mimeType ===
                                    "application/msword"

                                ) && (

                                <FileBadge

                                    type="DOCX"

                                    color="#2563eb"

                                    filename={message.filename}

                                    buttonText="Ver Documento"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {

                                message.type !== "sticker" &&

                                (

                                    message.mimeType ===
                                    "application/vnd.openxmlformats-officedocument.presentationml.presentation"

                                    ||

                                    message.filename?.toLowerCase()
                                    .endsWith(".pptx")

                                ) && (

                                <FileBadge

                                    type="PPTX"

                                    color="#ea580c"

                                    filename={message.filename}

                                    buttonText="Ver Presentación"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {

                                message.type !== "sticker" &&

                                (

                                    message.mimeType ===
                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"

                                    ||

                                    message.filename?.toLowerCase()
                                    .endsWith(".xlsx")

                                ) && (

                                <FileBadge

                                    type="XLSX"

                                    color="#15803d"

                                    filename={message.filename}

                                    buttonText="Ver Excel"

                                    onOpen={() =>

                                        openFileViewer(

                                            message.fileUrl,

                                            message.filename,

                                            message.mimeType

                                        )

                                    }

                                />

                                )
                            }

                            {
                                message.type !== "sticker" &&

                                !message.mimeType?.startsWith(
                                    "image/"
                                ) &&

                                message.mimeType !==
                                "application/pdf" &&

                                !message.mimeType?.startsWith(
                                    "audio/"
                                ) &&

                                message.mimeType !==
                                "application/msword" &&

                                message.mimeType !==
                                "application/vnd.openxmlformats-officedocument.wordprocessingml.document" &&

                                message.mimeType !==
                                "application/vnd.openxmlformats-officedocument.presentationml.presentation" &&

                                message.mimeType !==
                                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" &&

                                !message.filename?.toLowerCase()
                                .endsWith(".xlsx") && (

                                    <FileBadge

                                        type="FILE"

                                        color="#64748b"

                                        filename={message.filename}

                                        buttonText="Abrir"

                                        onOpen={() => {

                                            console.log(
                                                "ARCHIVO ABIERTO",
                                                {
                                                    filename:
                                                        message.filename,

                                                    mimeType:
                                                        message.mimeType,

                                                    fileUrl:
                                                        message.fileUrl
                                                }
                                            );

                                            openFileViewer(

                                                message.fileUrl,

                                                message.filename,

                                                message.mimeType

                                            );

                                        }}

                                    />

                                )
                            }

                            {
                            message.caption && (

                            <div
                            style={{
                                marginTop:8
                            }}
                            >

                                {message.caption}

                            </div>

                            )
                            }

                        {
                            message.fromMe &&
                            message.status === "sending" && (

                            <div
                            style={{
                            marginTop:6,
                            fontSize:11,
                            color:"#f59e0b"
                            }}
                            >

                            ⏳ Enviando...

                            </div>

                            )
                        }

                        {
                            message.fromMe &&
                            message.status === "sent" && (

                            <div
                            style={{
                            marginTop:6,
                            fontSize:11,
                            color:"#22c55e"
                            }}
                            >

                            ✓ Enviado

                            </div>

                            )
                        }

                        {
                            message.fromMe &&
                            message.status === "failed" && (

                            <div
                            style={{
                            marginTop:6,
                            fontSize:11,
                            color:"#ef4444"
                            }}
                            >

                            ✕ Error al enviar

                            </div>

                            )
                        }

                        </>

                        ) : (

                        message.body

                        )
                        }

                        </div>

                        <div style={{

                            fontSize:11,

                            color:"#64748b",

                            marginTop:6,

                            textAlign:

                                message.type === "sticker"

                                    ? "center"

                                    : "right"

                        }}>

                            {message.timestamp?.toDate
                            ? message.timestamp
                                .toDate()
                                .toLocaleTimeString(
                                    [],
                                    {
                                    hour:"2-digit",
                                    minute:"2-digit"
                                    }
                                )
                            : ""}

                        </div>

                    </div>

                </div>

                ))}

                <div ref={messagesEndRef} />

                </div>

                    </div>

                    {
                        audioPreview && (

                        <div
                            style={{
                                padding:16,
                                borderTop:"1px solid #e5e7eb",
                                background:"#fff"
                            }}
                        >

                            <audio

                                controls

                                src={audioPreview}

                                style={{
                                    width:"100%"
                                }}

                            />

                            <div
                                style={{
                                    display:"flex",
                                    justifyContent:"flex-end",
                                    gap:12,
                                    marginTop:12
                                }}
                            >

                                <button

                                    onClick={() => {

                                        setAudioBlob(null);

                                        setAudioPreview("");

                                    }}

                                >

                                    Eliminar

                                </button>

                                <button

                                    onClick={async () => {

                                        try {

                                            if (!audioBlob) {
                                                return;
                                            }

                                            const audioFile =
                                                new File(

                                                    [audioBlob],

                                                    `audio-${Date.now()}.webm`,

                                                    {
                                                        type:"audio/webm"
                                                    }

                                                );

                                            const {
                                                result,
                                                fileDoc
                                            } = await sendFileToWhatsApp({

                                                clinicId,

                                                phone: (
                                                    selectedConversation.whatsapp ||
                                                    selectedConversation.id ||
                                                    ""
                                                )
                                                .replace("@c.us", "")
                                                .replace(/\D/g, ""),

                                                file:
                                                    audioFile,

                                                caption:"",

                                                conversationId:
                                                    selectedConversation.id,

                                                patientId:
                                                    selectedConversation.patientId,

                                                db,

                                                storage,

                                                collection,

                                                addDoc,

                                                ref,

                                                uploadBytes,

                                                getDownloadURL

                                            });

                                            if (
                                                result?.success &&
                                                fileDoc?.id
                                            ) {

                                                await updateDoc(

                                                    doc(

                                                        db,

                                                        "clinics",

                                                        clinicId,

                                                        "whatsappConversations",

                                                        selectedConversation.id,

                                                        "messages",

                                                        fileDoc.id

                                                    ),

                                                    {

                                                        status:"sent"

                                                    }

                                                );

                                            }

                                            setAudioBlob(
                                                null
                                            );

                                            setAudioPreview(
                                                ""
                                            );

                                        } catch(error) {

                                            console.error(
                                                error
                                            );

                                            alert(
                                                error.message
                                            );

                                        }

                                    }}

                                >

                                    Enviar Audio

                                </button>

                            </div>

                        </div>

                        )
                    }

                <div className="vd-whatsapp-composer" style={{
                    padding:16,
                    borderTop:"1px solid #e5e7eb",
                    display:"flex",
                    gap:12,
                    alignItems:"center"
                }}>

                    {
                        showEmojiPicker && (

                        <div

                            ref={emojiPickerRef}

                            style={{

                                position:"fixed",

                                left:emojiPickerPosition.left,

                                top:emojiPickerPosition.top,

                                transform:"translateY(calc(-100% - 12px))",

                                zIndex:99999,

                                boxShadow:
                                    "0 15px 40px rgba(0,0,0,.20)",

                                borderRadius:18,

                                overflow:"hidden"

                            }}

                        >

                        <EmojiPicker

                            lazyLoadEmojis

                            previewConfig={{
                                showPreview:false
                            }}

                            skinTonesDisabled

                            onEmojiClick={(emoji)=>{

                                const input =
                                    messageInputRef.current;

                                if(!input){

                                    return;

                                }

                                const start =
                                    input.selectionStart;

                                const end =
                                    input.selectionEnd;

                                const text =
                                    newMessage;

                                const newText =

                                    text.substring(0,start)

                                    +

                                    emoji.emoji

                                    +

                                    text.substring(end);

                                setNewMessage(
                                    newText
                                );

                                requestAnimationFrame(()=>{

                                    input.focus();

                                    const pos =
                                        start +
                                        emoji.emoji.length;

                                    input.setSelectionRange(
                                        pos,
                                        pos
                                    );

                                });

                            }}

                        />

                        </div>

                        )
                    }

                    <button

                        type="button"

                        className="vd-wa-composer-icon vd-wa-composer-attach"

                        title="Adjuntar archivo"

                        aria-label="Adjuntar archivo"

                        onClick={() => {
                            setShowAttachmentMenu(
                                current => !current
                            );
                            setShowEmojiPicker(false);
                        }}

                        style={{
                            padding:"12px",
                            border:"none",
                            borderRadius:10,
                            cursor:"pointer",
                            background:"#f1f5f9"
                        }}

                    >

                        <Paperclip size={18} strokeWidth={2.2} />

                    </button>

                    {
                        showAttachmentMenu && (
                            <div
                                className="vd-wa-attachment-menu"
                                role="menu"
                                aria-label="Opciones de adjunto"
                            >
                                <button
                                    type="button"
                                    role="menuitem"
                                    onClick={() => openAttachmentPicker("image/*,video/*")}
                                >
                                    <ImageIcon size={17} strokeWidth={2.2} />
                                    <span>Fotos y videos</span>
                                </button>
                                <button
                                    type="button"
                                    role="menuitem"
                                    onClick={() => openAttachmentPicker(".pdf,.doc,.docx,.xls,.xlsx,.txt")}
                                >
                                    <FileText size={17} strokeWidth={2.2} />
                                    <span>Documento</span>
                                </button>
                            </div>
                        )
                    }

                    <input

                        ref={fileInputRef}

                        type="file"

                        style={{
                            display:"none"
                        }}

                        onChange={
                            handleFileSelected
                        }

                    />

                    <button

                        ref={emojiButtonRef}

                        type="button"

                        className="vd-wa-composer-icon vd-wa-composer-emoji"

                        title="Insertar emoji"

                        aria-label="Insertar emoji"

                        onClick={() => {

                            if(!showEmojiPicker){

                                const rect =
                                    emojiButtonRef.current.getBoundingClientRect();

                                setEmojiPickerPosition({

                                    left:rect.left,

                                    top:rect.top

                                });

                            }

                            setShowEmojiPicker(
                                prev => !prev
                            );

                        }}

                        style={{

                            padding:"12px",

                            border:"none",

                            borderRadius:10,

                            cursor:"pointer",

                            background:"#f1f5f9"

                        }}

                    >

                        <Smile size={19} strokeWidth={2.2} />

                    </button>

                    <button

                        type="button"

                        className={`vd-wa-composer-icon vd-wa-composer-mic${isRecording ? " is-recording" : ""}`}

                        title={isRecording ? "Detener grabación" : "Grabar audio"}

                        aria-label={isRecording ? "Detener grabación" : "Grabar audio"}

                        onClick={() => {

                            if (isRecording) {

                                stopRecording();

                            } else {

                                startRecording();

                            }

                        }}

                        style={{
                            padding:"12px",
                            border:"none",
                            borderRadius:10,
                            cursor:"pointer",
                            background:

                            isRecording
                            ? "#ef4444"
                            : "#f1f5f9"

                        }}

                    >

                        {isRecording ? <Square size={17} fill="currentColor" /> : <Mic size={19} strokeWidth={2.2} />}

                    </button>

                    {
                        isRecording && (

                        <div
                            style={{
                                fontSize:12,
                                color:"#ef4444",
                                minWidth:90,
                                display:"flex",
                                alignItems:"center"
                            }}
                        >

                            Grabando...
                            {" "}
                            {recordingTime}s

                        </div>

                        )
                    }

                    <input

                        ref={messageInputRef}

                        value={newMessage}

                        onChange={e =>
                            setNewMessage(
                            e.target.value
                            )
                        }

                        onKeyDown={e => {

                            if (e.key === "Enter") {

                                handleSendMessage();

                            }

                        }}

                        placeholder="Escribe un mensaje..."

                        style={{
                            flex:1,
                            padding:12,
                            borderRadius:10,
                            border:"1px solid #cbd5e1"
                        }}

                    />

                    <button

                        type="button"

                        className="vd-wa-composer-send"

                        title="Enviar mensaje"

                        aria-label="Enviar mensaje"

                        onClick={handleSendMessage}

                        style={{
                            padding:"12px 20px",
                            border:"none",
                            borderRadius:10,
                            background:"#2563eb",
                            color:"#fff",
                            cursor:"pointer"
                        }}

                    >

                        {sending ? <LoaderCircle size={18} className="vd-wa-spin" /> : <Send size={18} strokeWidth={2.2} />}

                    </button>

                </div>

            </>

        )}

        </div>

        {
            showFilePreview &&
            selectedFile && (

            <div
            style={{
            position:"fixed",
            inset:0,
            background:"rgba(0,0,0,.5)",
            display:"flex",
            alignItems:"center",
            justifyContent:"center",
            zIndex:9999
            }}
            >

            <div
            style={{
            background:"#fff",
            padding:24,
            borderRadius:16,
            width:450,
            maxWidth:"90%"
            }}
            >

            <h3>

            Archivo seleccionado

            </h3>

            {
                selectedFile?.type?.startsWith(
                    "image/"
                ) && (

                <div
                style={{
                    marginTop:20,
                    textAlign:"center"
                }}
                >

                <img

                    src={previewUrl}

                    alt="preview"

                    style={{
                        maxWidth:"100%",
                        maxHeight:300,
                        borderRadius:12,
                        border:"1px solid #e5e7eb"
                    }}

                />

                </div>

                )
            }

            {
                selectedFile?.type ===
                "application/pdf" && (

                <div
                style={{
                    marginTop:20,
                    padding:20,
                    border:"1px solid #e5e7eb",
                    borderRadius:12,
                    textAlign:"center"
                }}
                >

                <div
                style={{
                    fontSize:48
                }}
                >

                📄

                </div>

                <div>

                PDF

                </div>

                </div>

                )
            }

            {
                selectedFile &&
                !selectedFile.type.startsWith(
                    "image/"
                ) &&
                selectedFile.type !==
                "application/pdf" && (

                <div
                style={{
                    marginTop:20,
                    padding:20,
                    border:"1px solid #e5e7eb",
                    borderRadius:12,
                    textAlign:"center"
                }}
                >

                <div
                style={{
                    fontSize:48
                }}
                >

                📎

                </div>

                <div>

                Documento

                </div>

                </div>

                )
            }

            <div
            style={{
            marginTop:12
            }}
            >

            <strong>
            Nombre:
            </strong>

            {" "}

            {selectedFile.name}

            </div>

            <div
            style={{
            marginTop:8
            }}
            >

            <strong>
            Tamaño:
            </strong>

            {" "}

            {
            (
            selectedFile.size /
            1024
            ).toFixed(1)
            }

            KB

            </div>

            <div
                style={{
                marginTop:20
                }}
                >

                <input

                value={fileCaption}

                onChange={e =>
                    setFileCaption(
                    e.target.value
                    )
                }

                placeholder="Mensaje opcional..."

                style={{
                    width:"100%",
                    padding:12,
                    borderRadius:10,
                    border:"1px solid #cbd5e1"
                }}

                />

            </div>

            <div
            style={{
            marginTop:24,
            display:"flex",
            justifyContent:"flex-end",
            gap:12
            }}
            >

            <button

            onClick={() => {

                setShowFilePreview(
                false
                );

                setSelectedFile(
                null
                );

                setPreviewUrl(
                ""
                );

                setFileCaption(
                ""
                );

            }}

            >

            Cancelar

            </button>

            <button

                onClick={async () => {

                if (!selectedFile) {
                    return;
                }

                try {

                    setUploadingFile(
                    true
                    );
                console.log(
                "LLAMANDO sendFileToWhatsApp"
                );
                    const {
                        result,
                        fileDoc
                    } = await sendFileToWhatsApp({

                        clinicId,

                        phone: (
                            selectedConversation.whatsapp ||
                            selectedConversation.id ||
                            ""
                        )
                        .replace("@c.us", "")
                        .replace(/\D/g, ""),

                        file:
                            selectedFile,

                        caption:
                            fileCaption,

                        conversationId:
                            selectedConversation.id,

                        db,

                        storage,

                        collection,

                        addDoc,

                        ref,

                        uploadBytes,

                        getDownloadURL

                        });

                        console.log(
                        "SEND FILE RESULT:",
                        result
                        );

                        console.log(
                        "FILEDOC:",
                        fileDoc
                        );

                        console.log(
                        "FILEDOC ID:",
                        fileDoc?.id
                        );

                        console.log(
                        "ANTES DEL IF",
                        {
                            result,
                            fileDoc
                        }
                        );

                        if (result?.success) {

                            console.log(
                            "ENTRANDO A SENT"
                            );

                            try {

                            await updateDoc(
                                fileDoc,
                                {
                                status: "sent"
                                }
                            );

                            console.log(
                                "STATUS UPDATED TO SENT"
                            );

                            } catch(err) {

                            console.error(
                                "UPDATE SENT ERROR:",
                                err
                            );

                            }

                        } else {

                            console.log(
                            "ENTRANDO A FAILED"
                            );

                            try {

                            await updateDoc(
                                fileDoc,
                                {
                                status: "failed"
                                }
                            );

                            console.log(
                                "STATUS UPDATED TO FAILED"
                            );

                            } catch(err) {

                            console.error(
                                "UPDATE FAILED ERROR:",
                                err
                            );

                            }

                        }

                        console.log(
                        "DESPUES DE SEND FILE"
                        );

                        setShowFilePreview(
                        false
                        );

                        setSelectedFile(
                        null
                        );

                        setPreviewUrl(
                        ""
                        );

                        setFileCaption(
                        ""
                        );

                    //alert(
                    //"Archivo subido correctamente"
                    //);

                } catch(error) {

                    console.error(error);

                    alert(
                    error.message
                    );

                } finally {

                    setUploadingFile(
                    false
                    );

                }

                }}

                >

                {
                uploadingFile
                ? "Subiendo..."
                : "Enviar"
                }

            </button>

            </div>

            </div>

            </div>

          )
        }

        {showCreatePatient && (

            <PacienteForm

                onClose={() =>
                    setShowCreatePatient(false)
                }

                paciente={{

                    whatsappCountryCode:
                    "+52",

                    whatsapp:
                    (
                        selectedConversation?.whatsapp || ""
                    ).replace(/^521/, "")

                }}

                onSaved={async (nuevoPaciente) => {

                    console.log(
                        "PACIENTE CREADO:",
                        nuevoPaciente
                    );

                    try {

                        await updateDoc(

                        doc(
                            db,
                            "clinics",
                            clinicId,
                            "whatsappConversations",
                            selectedConversation.id
                        ),

                        {

                            patientId:
                            nuevoPaciente.id,

                            patientName:
                            `${nuevoPaciente.nombre || ""} ${nuevoPaciente.apellidos || ""}`.trim()

                        }

                        );

                    } catch (error) {

                        console.error(
                        "ERROR ACTUALIZANDO CONVERSACION:",
                        error
                        );

                    }

                    setShowCreatePatient(
                        false
                    );

                    }}

                />

            )}

            {
                showNewChatModal && (

                <div
                style={{
                position:"fixed",
                inset:0,
                background:"rgba(0,0,0,.5)",
                display:"flex",
                alignItems:"center",
                justifyContent:"center",
                zIndex:99999
                }}
                >

                <div
                style={{
                background:"#fff",
                width:500,
                maxWidth:"95%",
                borderRadius:16,
                padding:24
                }}
                >

                <h2>

                Nuevo Chat

                </h2>

                <div
                style={{
                marginTop:20
                }}
                >

                <select

                value={countryCode}

                onChange={e =>
                setCountryCode(
                e.target.value
                )
                }

                style={{
                width:"100%",
                padding:12,
                borderRadius:10
                }}
                >

                {
                countryCodes.map(country => (

                <option
                key={`${country.name}-${country.code}`}
                value={country.code}
                >

                {country.flag}
                {" "}
                {country.name}
                {" "}
                ({country.code})

                </option>

                ))
                }

                </select>

                </div>

                <input

                value={phoneSearch}

                onChange={e =>
                setPhoneSearch(
                e.target.value
                )
                }

                placeholder="Número telefónico"

                style={{
                width:"100%",
                padding:12,
                marginTop:12,
                borderRadius:10,
                border:"1px solid #cbd5e1"
                }}

                />

                <input

                value={patientSearch}

                onChange={e =>
                searchPatients(
                e.target.value
                )
                }

                placeholder="Buscar paciente"

                style={{
                width:"100%",
                padding:12,
                marginTop:12,
                borderRadius:10,
                border:"1px solid #cbd5e1"
                }}

                />

                <h3
                    style={{
                    marginTop:20,
                    marginBottom:10
                    }}
                    >

                    Pacientes recientes

                </h3>

                <div
                style={{
                marginTop:16,
                maxHeight:250,
                overflowY:"auto",
                border:"1px solid #e5e7eb",
                borderRadius:10
                }}
                >

                {
                patientSearch.trim() === "" &&

                recentPatients.map(patient => (

                <div

                key={patient.id}

                onClick={() => {

                const cleanWhatsapp =
                    (patient.whatsapp || "")
                        .replace(/\D/g, "");

                const phone =
                    cleanWhatsapp.startsWith("52")
                        ? cleanWhatsapp
                        : countryCode.replace("+", "") + cleanWhatsapp;

                setSelectedConversation({

                id:
                `${phone}@c.us`,

                whatsapp:
                phone,

                patientId:
                patient.id,

                patientName:

                `${patient.nombre || ""} ${patient.apellidos || ""}`

                });

                setShowNewChatModal(
                false
                );

                }}

                style={{
                padding:12,
                cursor:"pointer",
                borderBottom:
                "1px solid #f1f5f9"
                }}
                >

                <div
                style={{
                fontWeight:600
                }}
                >

                {patient.nombre}
                {" "}
                {patient.apellidos}

                </div>

                <div
                style={{
                fontSize:12,
                color:"#64748b"
                }}
                >

                {patient.whatsapp}

                </div>

                </div>

                ))
                }

                {
                patientSearch.trim() !== "" &&

                patientsFound.map(patient => (

                <div

                key={patient.id}

                onClick={() => {

                const cleanWhatsapp =
                    (patient.whatsapp || "")
                        .replace(/\D/g, "");

                const phone =
                    cleanWhatsapp.startsWith("52")
                        ? cleanWhatsapp
                        : countryCode.replace("+", "") + cleanWhatsapp;

                setSelectedConversation({

                id:
                `${phone}@c.us`,

                whatsapp:
                phone,

                patientId:
                patient.id,

                patientName:

                `${patient.nombre || ""} ${patient.apellidos || ""}`

                });

                setShowNewChatModal(
                false
                );

                }}

                style={{
                padding:12,
                cursor:"pointer",
                borderBottom:
                "1px solid #f1f5f9"
                }}
                >

                <div
                style={{
                fontWeight:600
                }}
                >

                {patient.nombre}
                {" "}
                {patient.apellidos}

                </div>

                <div
                style={{
                fontSize:12,
                color:"#64748b"
                }}
                >

                {patient.whatsapp}

                </div>

                </div>

                ))
                }

                </div>

                <div
                style={{
                display:"flex",
                justifyContent:"flex-end",
                gap:12,
                marginTop:20
                }}
                >

                <button

                onClick={() =>
                setShowNewChatModal(
                false
                )
                }

                >

                Cancelar

                </button>

                <button

                onClick={() => {

                const cleanPhone =
                    phoneSearch.replace(/\D/g, "");

                const phone =
                    cleanPhone.startsWith("52")
                        ? cleanPhone
                        : countryCode.replace("+", "") + cleanPhone;

                setSelectedConversation({

                id:
                `${phone}@c.us`,

                whatsapp:
                phone,

                patientId:null,

                patientName:""

                });

                setShowNewChatModal(
                false
                );

                }}

                >

                Abrir Chat

                </button>

                </div>

                </div>

                </div>

                )
            }

            {showLinkPatientModal && (
                <div
                    onClick={() => setShowLinkPatientModal(false)}
                    style={{
                        position: "fixed",
                        inset: 0,
                        background: "rgba(0,0,0,.45)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 10000
                    }}
                >
                    <div
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            width: 500,
                            maxWidth: "95%",
                            maxHeight: "80vh",
                            background: "#fff",
                            borderRadius: 12,
                            padding: 20,
                            display: "flex",
                            flexDirection: "column",
                            gap: 16
                        }}
                    >

                        <h2 style={{ margin: 0 }}>
                            Vincular paciente existente
                        </h2>

                        <input
                            type="text"
                            placeholder="Buscar paciente..."
                            value={linkPatientSearch}
                            onChange={(e) => {

                                setLinkPatientSearch(e.target.value);

                                searchPatients(
                                    e.target.value,
                                    "link"
                                );

                            }}
                            style={{
                                padding: 10,
                                border: "1px solid #ccc",
                                borderRadius: 8
                            }}
                        />

                        <div
                            style={{
                                flex: 1,
                                minHeight: 250,
                                border: "1px solid #eee",
                                borderRadius: 8,
                                overflowY: "auto"
                            }}
                        >

                            {linkPatientsFound.length === 0 ? (

                                <div
                                    style={{
                                        color:"#666",
                                        textAlign:"center",
                                        marginTop:100
                                    }}
                                >
                                    No hay resultados.
                                </div>

                            ) : (

                                linkPatientsFound.map(patient => (

                                    <div

                                        key={patient.id}

                                        onClick={async () => {

                                            if (linkingPatient) {
                                                return;
                                            }

                                            setLinkingPatient(true);

                                            try {

                                                const patientName =
                                                    `${patient.nombre || ""} ${patient.apellidos || ""}`.trim();

                                                const phone = (
                                                    linkConversation.whatsapp ||
                                                    linkConversation.id.replace("@c.us", "")
                                                )
                                                .replace(/^521/, "52")
                                                .replace(/\D/g, "");

                                                // ===========================
                                                // Verificar conflicto
                                                // ===========================

                                                const pacientesRef = patientDirectory(db,clinicId);

                                                const pacientesSnap = await getDocs(
                                                    pacientesRef
                                                );

                                                const conflicto = pacientesSnap.docs.find(docSnap => {

                                                    if (docSnap.id === patient.id) {
                                                        return false;
                                                    }

                                                    const whatsapp = (
                                                        docSnap.data().whatsapp || ""
                                                    ).replace(/\D/g, "");

                                                    return whatsapp === phone;

                                                });

                                                if (conflicto) {

                                                    alert(
                                                        "Ese número de WhatsApp ya está asignado a otro paciente."
                                                    );

                                                    setLinkingPatient(false);

                                                    return;

                                                }

                                                // ===========================
                                                // Batch
                                                // ===========================

                                                const batch = writeBatch(db);

                                                // Conversación

                                                batch.update(

                                                    doc(
                                                        db,
                                                        "clinics",
                                                        clinicId,
                                                        "whatsappConversations",
                                                        linkConversation.id
                                                    ),

                                                    {
                                                        patientId: patient.id,
                                                        patientName: patientName
                                                    }

                                                );

                                                // Mensajes

                                                const messagesRef = collection(
                                                    db,
                                                    "clinics",
                                                    clinicId,
                                                    "whatsappConversations",
                                                    linkConversation.id,
                                                    "messages"
                                                );

                                                const messagesSnap = await getDocs(
                                                    messagesRef
                                                );

                                                messagesSnap.forEach(message => {

                                                    batch.update(

                                                        message.ref,

                                                        {
                                                            patientId: patient.id,
                                                            patientName: patientName
                                                        }

                                                    );

                                                });

                                                // Paciente

                                                batch.update(

                                                    doc(
                                                        db,
                                                        "clinics",
                                                        clinicId,
                                                        "pacientes",
                                                        patient.id
                                                    ),

                                                    {
                                                        whatsapp: phone
                                                    }

                                                );

                                                await batch.commit();

                                                setShowLinkPatientModal(false);

                                            } catch(error) {

                                                console.error(error);

                                                alert("Error al vincular paciente.");

                                            } finally {

                                                setLinkingPatient(false);

                                            }

                                        }}

                                        style={{

                                            padding:12,

                                            cursor:"pointer",

                                            borderBottom:"1px solid #f1f5f9"

                                        }}

                                    >

                                        <div
                                            style={{
                                                fontWeight:600
                                            }}
                                        >

                                            {patient.nombre} {patient.apellidos}

                                        </div>

                                        <div
                                            style={{
                                                fontSize:12,
                                                color:"#64748b"
                                            }}
                                        >

                                            {patient.whatsapp}

                                        </div>

                                    </div>

                                ))

                            )}

                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: 10
                            }}
                        >
                            <button
                                onClick={() => setShowLinkPatientModal(false)}
                            >
                                Cancelar
                            </button>
                        </div>

                    </div>
                </div>
            )}

            {
                console.log(
                    "FILEVIEWER PROPS",
                    {
                        viewerName,
                        viewerMimeType,
                        viewerUrl
                    }
                )
            }

        {
            showDeleteConversationModal && (

            <div
            style={{

                position:"fixed",

                inset:0,

                background:"rgba(0,0,0,.45)",

                display:"flex",

                alignItems:"center",

                justifyContent:"center",

                zIndex:99999

            }}
            >

            <div
            style={{

                width:430,

                maxWidth:"90%",

                background:"#fff",

                borderRadius:18,

                padding:28,

                boxShadow:

                "0 20px 60px rgba(0,0,0,.25)"

            }}
            >

            <div
            style={{

                fontSize:22,

                fontWeight:700,

                marginBottom:20

            }}
            >

            Eliminar conversación

            </div>

            <div
            style={{

                lineHeight:1.6,

                color:"#475569",

                marginBottom:28

            }}
            >

            ¿Deseas eliminar esta conversación de VexaDent?

            <br/><br/>

            Esta acción <b>NO</b> eliminará la conversación del teléfono ni de WhatsApp.

            <br/><br/>

            Si el paciente vuelve a escribir, la conversación se creará nuevamente.

            </div>

            <div
            style={{

                display:"flex",

                justifyContent:"flex-end",

                gap:12

            }}
            >

            <button

            onClick={()=>

            setShowDeleteConversationModal(
            false
            )

            }

            style={{

            padding:"10px 18px",

            borderRadius:10,

            border:"1px solid #cbd5e1",

            background:"#fff",

            cursor:"pointer"

            }}

            >

            Cancelar

            </button>

            <button

            onClick={
            confirmDeleteConversation
            }

            style={{

            padding:"10px 18px",

            borderRadius:10,

            border:"none",

            background:"#dc2626",

            color:"#fff",

            fontWeight:600,

            cursor:"pointer"

            }}

            >

            Eliminar conversación

            </button>

            </div>

            </div>

            </div>

            )
        }

        <FileViewerModal

            isOpen={
                viewerOpen
            }

            onClose={() => {

                setViewerOpen(
                    false
                );

                setViewerUrl(
                    ""
                );

                setViewerName(
                    ""
                );

                setViewerMimeType(
                    ""
                );

            }}

            title={
                viewerName
            }

            fileUrl={
                viewerUrl
            }

            filename={
                viewerName
            }

            mimeType={
                viewerMimeType
            }

            onWhatsApp={() => {}}

        />

    </div>

  );

}
